// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"OffersPeriodic_wrapperComponent__yT74N","header":"OffersPeriodic_header__WESnz","searchFormWrapper":"OffersPeriodic_searchFormWrapper__rhQSB"};